import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Service Areas", href: "/location" },
  { label: "Contact Us", href: "/contact" },
  { label: "Get a Free Estimate", href: "/contact" },
];

const SERVICE_LINKS = [
  { label: "Plumbing Services", href: "/plumbing" },
  { label: "Drain Cleaning", href: "/plumbing" },
  { label: "Water Heater Repair", href: "/services" },
  { label: "Grease Trap Installation", href: "/services" },
  { label: "Welding Services", href: "/services" },
  { label: "Emergency Services", href: "/contact" },
];

const SERVICE_CITIES = [
  "Cedar Hill", "Arlington", "Fort Worth",
  "Dallas", "Grand Prairie", "Mansfield",
  "Irving", "Burleson", "Keller",
];

export default function Footer() {
  return (
    <footer className="bg-[#0F1C0F]" style={{ fontFamily: "'Inter', sans-serif" }}>
      {/* Top CTA Banner */}
      <div className="bg-[#E8500A]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div>
              <p className="text-white/70 text-xs font-semibold tracking-widest uppercase mb-1">Available 24/7</p>
              <h3
                className="text-2xl font-black text-white"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                Plumbing Emergency? Call Us Now.
              </h3>
            </div>
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="tel:8178324968"
                className="flex items-center gap-2 bg-white text-[#E8500A] font-black px-7 py-3.5 rounded-lg text-base transition-colors hover:bg-orange-50 whitespace-nowrap"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                <i className="ri-phone-fill" />
                (817) 832-4968
              </a>
              <Link
                to="/contact"
                className="flex items-center gap-2 border-2 border-white/40 hover:border-white text-white font-bold px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap"
              >
                Request Service Online
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://jerrysplumbingheating.com/wp-content/uploads/2022/04/jerrys-plumbing-welding-dfw-logo.png"
              alt="Jerry's Plumbing Heating & Welding — Licensed DFW Plumber"
              className="h-14 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-[#8A9A8A] text-sm leading-relaxed mb-5">
              Premier residential and commercial plumbing, heating &amp; welding across the DFW metroplex for over 35 years. Owned by a Texas Master Plumber.
            </p>
            <div className="inline-flex items-center gap-2 bg-[#E8500A]/15 border border-[#E8500A]/30 rounded-full px-3.5 py-1.5">
              <i className="ri-shield-check-fill text-[#E8500A] text-sm" />
              <span className="text-[#E8500A] text-xs font-bold tracking-wide">LIC #M12160</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 id="footer-quick-links" className="font-bold text-xs tracking-widest uppercase text-[#E8500A] mb-5">
              <a href="#footer-quick-links">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="flex items-center gap-2 text-[#8A9A8A] hover:text-white text-sm transition-colors"
                  >
                    <i className="ri-arrow-right-s-line text-[#E8500A] flex-shrink-0" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 id="footer-services" className="font-bold text-xs tracking-widest uppercase text-[#E8500A] mb-5">
              <a href="#footer-services">Our Services</a>
            </h4>
            <ul className="space-y-3">
              {SERVICE_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="flex items-center gap-2 text-[#8A9A8A] hover:text-white text-sm transition-colors"
                  >
                    <i className="ri-arrow-right-s-line text-[#E8500A] flex-shrink-0" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="font-bold text-xs tracking-widest uppercase text-[#8A9A8A]/50 mb-3 mt-6">DFW Cities Served</h4>
            <div className="flex flex-wrap gap-1.5">
              {SERVICE_CITIES.map((city) => (
                <span
                  key={city}
                  className="text-[#8A9A8A] text-xs bg-white/5 rounded px-2 py-1"
                >
                  {city}
                </span>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 id="footer-contact" className="font-bold text-xs tracking-widest uppercase text-[#E8500A] mb-5">
              <a href="#footer-contact">Contact Us</a>
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://maps.app.goo.gl/oqw8JCNvgSRZngpEA"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-start gap-3 text-[#8A9A8A] hover:text-white text-sm transition-colors"
                >
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-2-fill text-[#E8500A]" />
                  </span>
                  <span>440 Whitney St<br />Cedar Hill, TX 75104</span>
                </a>
              </li>
              <li>
                <a href="tel:8178324968" className="flex items-center gap-3 text-[#8A9A8A] hover:text-white text-sm transition-colors">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-fill text-[#E8500A]" />
                  </span>
                  Arlington: <strong className="text-white ml-1">(817) 832-4968</strong>
                </a>
              </li>
              <li>
                <a href="tel:9722625113" className="flex items-center gap-3 text-[#8A9A8A] hover:text-white text-sm transition-colors">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-fill text-[#E8500A]" />
                  </span>
                  Dallas: <strong className="text-white ml-1">(972) 262-5113</strong>
                </a>
              </li>
              <li>
                <a href="mailto:jph832@yahoo.com" className="flex items-center gap-3 text-[#8A9A8A] hover:text-white text-sm transition-colors">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-fill text-[#E8500A]" />
                  </span>
                  jph832@yahoo.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-fill text-[#E8500A]" />
                </span>
                <span className="text-white font-bold">24/7 Emergency Service</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#4A5A4A] text-xs">
            TX Master Plumber LIC #M12160 &nbsp;&bull;&nbsp; &copy;2026 Jerry&apos;s Plumbing, Heating &amp; Welding. All Rights Reserved.
          </p>
          <p className="text-[#4A5A4A] text-xs">
            Serving Dallas–Fort Worth, TX for 35+ Years
          </p>
        </div>
      </div>
    </footer>
  );
}
